export const WholesalerEntryPointIconic = 'Iconic' as const
export const WholesalerEntryPointProSeries = 'Pro Series' as const

export function isWholesalerEntryPointValid(entryPoint: string): boolean {
  return entryPoint === WholesalerEntryPointIconic
    || entryPoint === WholesalerEntryPointProSeries
}